import { Tooltip } from "@component/tooltip";

interface CompanyHeaderProps {
    companyLogo?: string;
    companyName?: string;
}

export default function PreviewCompanyHeader({
    companyLogo,
    companyName = "Your Company",
}: CompanyHeaderProps) {
    const defaultCompanyLogo = "https://assets.polymet.ai/eligible-rose-215732"; // ourteam logo

    return (
        <div className="text-center">
            <div
                className="flex items-center justify-center p-0 min-h-[5rem]"
            >
                <Tooltip
                    content={
                        <p>Your Company Logo will appear here.</p>
                    }
                    side="top"
                    delayDuration={0}
                >
                    <img
                        src={companyLogo || defaultCompanyLogo}
                        alt={companyName || "Company"}
                        className="max-w-32 max-h-20 object-contain flex-shrink-0"
                    />
                </Tooltip>
            </div>
        </div>
    );
}
